export default function formatarScoreRisco(
  score,
  separadorMilhar = '.',
  separadorDecimal = ','
) {  
  if (score === null || score === undefined || score === '') return '';

  const numero = Number(score);
  if (Number.isNaN(numero)) return '';

  const casas = Number.isInteger(numero) ? 0 : 2;

  const fator = Math.pow(10, casas);
  const valorArredondado =
    casas > 0
      ? (numero >= 0
          ? Math.round(numero * fator + Number.EPSILON)
          : Math.round(numero * fator - Number.EPSILON)) / fator
      : numero;

  let [inteiro, decimal] = valorArredondado
    .toFixed(casas)
    .split('.');

  inteiro = inteiro.replace(/\B(?=(\d{3})+(?!\d))/g, separadorMilhar);

  return decimal
    ? `${inteiro}${separadorDecimal}${decimal}`
    : inteiro;
}  
